import { GOALS } from '../lib/goals';
import { COMPOUNDS } from '../lib/compounds';

export function renderHome() {
  const app = document.getElementById('app')!;
  app.innerHTML = `
    <section class="hero">
      <img src="/icon.jpg" alt="MyStack" style="width:240px;height:240px;border-radius:36px;display:block;margin:0 auto 14px;box-shadow:0 6px 24px rgba(0,0,0,0.5);" />
      <p>Build your supplement stack from the same research a clinician would read — paraphrased into plain English with every claim cited. No paywall. Vendor links may pay us a small cut.</p>
      <div class="cta">
        <a class="btn btn-primary" href="/compounds">Browse compounds</a>
        <a class="btn" href="/mystack.apk" download>📱 Download Android APK</a>
        <a class="btn" href="/login">Sign in to save stacks</a>
      </div>
      <p style="font-size:12px;color:var(--dim);margin-top:8px;">APK installs outside the Play Store — you may need to allow "install unknown apps" for your browser.</p>
    </section>

    <h2 class="section-title">Pick a goal</h2>
    <div class="goals-grid">
      ${GOALS.map((g) => `
        <a class="goal-card" href="/g/${esc(g.id)}">
          <div class="icon">${g.icon}</div>
          <div class="label">${esc(g.label)}</div>
        </a>
      `).join('')}
    </div>

    <h2 class="section-title">All compounds · ${COMPOUNDS.length}</h2>
    <div class="compound-grid">
      ${COMPOUNDS.map(compoundCard).join('')}
    </div>
  `;
}

export function compoundCard(c: { id: string; display_name: string; scientific_name: string; description: string; evidence_stars: number; goals: string[] }) {
  const stars = '★'.repeat(c.evidence_stars) + '<span class="stars-empty">' + '★'.repeat(5 - c.evidence_stars) + '</span>';
  const teaser = c.description.length > 140 ? c.description.slice(0, 140) + '…' : c.description;
  return `
    <a class="compound-card" href="/c/${esc(c.id)}">
      <div class="name">${esc(c.display_name)}</div>
      <div class="sci">${esc(c.scientific_name)}</div>
      <div class="desc">${esc(teaser)}</div>
      <div class="meta"><span class="stars">${stars}</span> &nbsp; evidence</div>
      <div class="tags">${c.goals.map((g) => `<span class="tag">${esc(g)}</span>`).join('')}</div>
    </a>
  `;
}

function esc(s: string) {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
